import { css } from 'styled-components';

const CheckboxElement = css`
padding: 0;
height: initial;
width: initial;
margin-bottom: 0;
display: none;
cursor: pointer;
&:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 0px;
  left: 8px;
  width: 4px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

&:checked + label:before {
  background-color: #278ECD;
  border: 2px solid #278ECD;
}
`;

export default CheckboxElement;
